import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { PagePreviews } from './components/PagePreviews';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Steps } from './components/Steps';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="2wj8e3qc26q58">
      <MetaPixel data-id="element-1" data-mp="28tw4ipctkg2e" />
      <main data-id="element-2" data-mp="28te2fc3h77mk">
        <Hero data-id="element-3" data-mp="28suumo7jhzm9" />
        <Stats data-id="element-4" data-mp="28sl5t3y8dyi5" />
        <Testimonials data-id="element-5" data-mp="28s2ztflro5x1" />
        <PainPoints data-id="element-6" data-mp="23vuo6c6s2uum" />
        <Volumes data-id="element-7" data-mp="23u9ueosaffxt" />
        <PagePreviews data-id="element-8" data-mp="23utby4e102bb" />
        <Bonuses data-id="element-9" data-mp="23t8ea5wf0398" />
        <Countdown spotsTaken={89} data-id="element-10" data-mp="3ijxsgzk2wgo4" />
        <Pricing data-id="element-11" data-mp="3iiwfuqnezm4a" />
        <Steps data-id="element-12" data-mp="3ijfu9xduvsdk" />
        <FAQ data-id="element-13" data-mp="3ihv048vgebg8" />
        <Countdown spotsTaken={89} data-id="element-14" data-mp="3mlja0y7k5j4n" />
        <ValueStack data-id="element-15" data-mp="3mkrgdsxitvh0" />
      </main>
      <Footer data-id="element-16" data-mp="3mjq2lgp4euvl" />
    </div>;
}